import shonanPalmLogo from "../../assets/shonan-palm-gold-transparent.png";

export default function PublicBrandMark({
  href = "/book",
  onClick,
  className = "",
  variant = "header",
  showSubtitle = true,
  fluidMobile = false,
}) {
  const isCeremonial = variant === "ceremonial";

  const content = isCeremonial ? (
    <div className="flex flex-col items-center">
      <span className="shonan-brand-logo-unframed inline-flex h-20 w-20 items-center justify-center">
        <img
          src={shonanPalmLogo}
          alt="Shonan International"
          className="h-full w-full object-contain drop-shadow-[0_0_26px_rgba(215,183,107,0.62)]"
        />
      </span>
      <span className="mt-7 flex w-full max-w-[520px] items-center gap-4">
        <span className="h-px flex-1 bg-gradient-to-r from-transparent to-[#d7b76b]/52" />
        <span className="text-center">
          <span className="block font-serif text-lg tracking-[0.28em] text-[#d7b76b] sm:text-2xl">
            SHONAN INTERNATIONAL
          </span>
          <span className="mt-2 block text-[10px] font-semibold tracking-[0.34em] text-white/48 sm:text-[11px]">
            Private Transfer & Charter
          </span>
        </span>
        <span className="h-px flex-1 bg-gradient-to-l from-transparent to-[#d7b76b]/52" />
      </span>
    </div>
  ) : (
    <>
      <span className="shonan-brand-logo-unframed inline-flex h-10 w-10 shrink-0 items-center justify-center">
        <img
          src={shonanPalmLogo}
          alt="Shonan International"
          className="h-full w-full object-contain drop-shadow-[0_0_22px_rgba(215,183,107,0.52)]"
        />
      </span>
      <span className="grid gap-1">
        <span className="whitespace-nowrap font-serif text-[10px] font-semibold tracking-[0.16em] text-[#d7b76b] sm:text-[15px] sm:tracking-[0.26em]">
          SHONAN INTERNATIONAL
        </span>
        {showSubtitle && (
          <span className="block whitespace-nowrap text-[7px] font-semibold tracking-[0.12em] text-white/48 sm:text-[10px] sm:tracking-[0.28em]">
            Private Transfer & Charter
          </span>
        )}
      </span>
    </>
  );

  const commonClassName = isCeremonial
    ? `inline-flex justify-center text-center ${className}`
    : `inline-flex h-11 items-center gap-3 text-left ${className}`;
  const commonStyle = isCeremonial
    ? undefined
    : { width: fluidMobile ? "min(470px, calc(100vw - 32px))" : "min(470px, calc(100vw - 128px))" };

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={commonClassName} style={commonStyle} aria-label="Shonan International">
        {content}
      </button>
    );
  }

  if (!href) {
    return <div className={commonClassName} style={commonStyle}>{content}</div>;
  }

  return (
    <a href={href} className={commonClassName} style={commonStyle} aria-label="Shonan International">
      {content}
    </a>
  );
}
